import * as React from "react";
import { useParams } from "react-router";
import { Toolbar, Typography } from "@material-ui/core";
import { getUserInfo } from "../../sdk/users";
import { AdminUserDetailsResponse } from "../../../../../services/user-admin/types/api/user-details-response";
import { UserAccountStatus } from "./components/user-account-status";
import { UserLoginOptions } from "./components/user-login-options";
import { UserArtistList } from "./components/user-artist-list";

export const UserDetailPage: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();

  const [loading, setLoading] = React.useState(false);
  const [user, setUser] = React.useState<AdminUserDetailsResponse>();

  React.useEffect(() => {
    setLoading(true);
    getUserInfo(userId)
      .then((data) => {
        setUser(data);
      })
      .finally(() => setLoading(false));
  }, [userId]);

  if (!user) {
    return null;
  }

  return (
    <section>
      <Toolbar variant="dense" style={{ marginTop: "20px" }}>
        <Typography variant="h4" style={{ flexGrow: 1 }}>{`${user.givenName} ${
          user.familyName
        } (${user.email || user.telephone})`}</Typography>
      </Toolbar>

      <div style={{ display: "flex", marginTop: "20px" }}>
        <UserAccountStatus
          style={{ marginRight: "20px" }}
          user={user}
          loading={loading}
        />
        <UserLoginOptions user={user} loading={loading} />
      </div>

      {/* <EarningsSummaryComponent style={{marginTop: '20px'}} summary={summary} /> */}
      <UserArtistList style={{ marginTop: "20px" }} artists={user.artists} />
    </section>
  );
};
